import React from 'react';
//import PropTypes from 'prop-types';
import cn from "classnames"
import injectSheet from 'react-jss';
import theme from "../../styles/theme"

function Subtitle(props) {
    const { classes, className, children } = props;
    return <p className={cn( classes.subTitle, classes.globalParagraphLetterSpacingReset, className )} data-cy="subtitle">{children}</p>;
}

//Subtitle.propTypes = {
//};

export default injectSheet(
    {
        subTitle: {
            ...theme.font.subtitle
        },
        globalParagraphLetterSpacingReset: {
            letterSpacing: 'normal'
        },
    }
)(Subtitle);



// WEBPACK FOOTER //
// ./src/components/Widgets/Subtitle.js